import React from 'react'
import {AUTH_PREFIX_PATH, APP_PREFIX_PATH, EDITOR_PREFIX_PATH} from 'configs/AppConfig'

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
]


export const protectedRoutes = [
    {
        key: 'clients',
        path: `${APP_PREFIX_PATH}/clients`,
        component: React.lazy(() => import('views/app-views/clients/list')),
    },
    {
        key: 'commandes',
        path: `${APP_PREFIX_PATH}/commandes`,
        component: React.lazy(() => import('views/app-views/commandes/list')),
    },
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/dashboards/default')),
    },
    {
        key: 'stocks',
        path: `${APP_PREFIX_PATH}/stock`,
        component: React.lazy(() => import('views/app-views/stocks/list')),
    }
]
